import React from 'react';

const Loading = () => (
  <div className="btn-loading">
    <span className="btn-loading__bounce btn-loading__bounce1" />
    <span className="btn-loading__bounce btn-loading__bounce2" />
    <span className="btn-loading__bounce btn-loading__bounce3" />
  </div>
);

export default Loading;
